import { render } from "./Subprogram.vue?vue&type=template&id=1b7935b4"
import script from "./Subprogram.vue?vue&type=script&lang=js"
export * from "./Subprogram.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__